// Lib
import chroma from 'chroma-js';
import { Thunk } from '../../../../../types/reduxTypes';
import Immutable from 'immutable';

// Actions
import { getNewElementId } from '../../../../../element/actions/elementActions';
import { createLabel, loadLabels } from '../../../../../../common/labels/labelActions';
import { addLabelToElements } from '../../../../../element/labels/elementLabelActions';
import { getNewTransactionId } from '../../../../../utils/undoRedo/undoRedoTransactionManager';

// Types
import { ImMNElement } from '../../../../../../common/elements/elementModelTypes';
import { Label, LabelCreationData } from '../../../../../../common/labels/labelTypes';
import { selectCurrentUserLabels } from '../../../../../element/labels/labelSelectors';
import { prop } from '../../../../../../common/utils/immutableHelper';
import { uniq } from 'lodash/fp';
import { fetchLabelsByIds } from '../../../../../element/labels/labelsService';

export const createNewLabelThunk =
    (labelData: LabelCreationData, transactionId?: number): Thunk<Label> =>
    (dispatch: Function) => {
        const id = dispatch(getNewElementId());

        const { name, creator, color } = labelData;
        const label = {
            id,
            name,
            color: color || chroma.random().hex(),
            meta: {
                creator,
                createdTime: Date.now(),
                modifiedTime: Date.now(),
            },
        };

        dispatch(createLabel(label, transactionId));
        return label;
    };

export const addLabelToElementsThunk =
    (label: Label, elements: Immutable.List<ImMNElement>, transactionId?: number): Thunk =>
    (dispatch: Function) => {
        dispatch(addLabelToElements(elements, label.id, transactionId));
    };

export const createAndAddLabelToElementsThunk =
    (labelData: LabelCreationData, elements: Immutable.List<ImMNElement>): Thunk =>
    (dispatch: Function) => {
        const sharedTransactionId = getNewTransactionId();
        const newLabel = dispatch(createNewLabelThunk(labelData, sharedTransactionId));
        dispatch(addLabelToElementsThunk(newLabel, elements, sharedTransactionId));
    };

export const fetchAndLoadLabelsByIdsThunk =
    (labelIds: string[]): Thunk =>
    async (dispatch: Function, getState: Function) => {
        const labels = selectCurrentUserLabels(getState()) || {};
        const hasLabel = (labelId: string) => prop(labelId, labels);
        const unknownLabelIds = uniq(labelIds.filter((labelId) => labelId && !hasLabel(labelId)));

        if (!unknownLabelIds.length) return;

        const fetchedLabels = await fetchLabelsByIds(unknownLabelIds);
        if (!fetchedLabels.length) return;

        dispatch(loadLabels(fetchedLabels));
    };
